<router-outlet></router-outlet>
@if (sharedService.rootData.viewLoading) {
<mat-progress-spinner class="loader-pos loader-custom SF-loader" mode="indeterminate" [diameter]="50">
</mat-progress-spinner>
}
